import { forwardRef, type SVGProps } from "react";

export const BankIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={ariaHidden}
      >
        <title>Bank account icon</title>
        <path
          d="M2.33594 6.00016L8.0026 3.3335L13.6693 6.00016V7.3335H2.33594V6.00016Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
        <path
          d="M3.33594 7.3335V10.6668"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M6.33594 7.3335V10.6668"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M9.66927 7.3335V10.6668"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M12.6693 7.3335V10.6668"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
        <path
          d="M2.33594 12.6668H13.6693"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
        />
      </svg>
    );
  },
);
BankIcon.displayName = "BankIcon";

export const WalletIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={ariaHidden}
      >
        <title>Wallet icon</title>
        <path
          d="M3 8.66615C3 6.35549 4.66533 4.38215 6.94267 3.99282L15.692 2.49949C16.2707 2.40082 16.8467 2.69282 17.1093 3.21815"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 15.6654V17.6654C21 19.1387 19.8067 20.332 18.3333 20.332H5.66667C4.19333 20.332 3 19.1387 3 17.6654V8.9987C3 7.52536 4.19333 6.33203 5.66667 6.33203H18.3333C19.8067 6.33203 21 7.52536 21 8.9987V10.9987"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 15.6667H17.3333C16.0453 15.6667 15 14.6213 15 13.3333C15 12.044 16.0453 11 17.3333 11H21C21.736 11 22.3333 11.5973 22.3333 12.3333V14.3333C22.3333 15.0693 21.736 15.6667 21 15.6667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
WalletIcon.displayName = "WalletIcon";

export const LinkIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { title?: string }
>(({ className, title = "Link", ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      viewBox="0 0 72 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{title}</title>
      <path
        fill="#0A2540"
        d="M36.12 3.67683c0-1.12801.9504-2.04481 2.0688-2.04481 1.1184 0 2.0688.9216 2.0688 2.04481 0 1.1232-.9168 2.0688-2.0688 2.0688-1.152 0-2.0688-.9168-2.0688-2.0688ZM29.9808 1.92001h3.6V22.08h-3.6V1.92001ZM40.008 7.68001h-3.6288V22.08h3.6288V7.68001ZM66.096 14.3904c2.7312-1.68 4.5888-4.1808 5.3232-6.71516h-3.6288c-.9456 2.41916-3.1152 4.23836-5.5008 5.01116V1.91523h-3.6288V22.0752h3.6288V16.08c2.7696.6912 4.9584 3.0864 5.7072 5.9952h3.6528c-.5568-3.0528-2.6448-5.9088-5.5536-7.6848ZM46.44 9.29283c.9504-1.2624 2.8032-1.99681 4.3056-1.99681 2.8032 0 5.1216 2.04961 5.1264 5.14558v9.6336h-3.6288v-8.832c0-1.272-.5664-2.7408-2.4048-2.7408-2.16 0-3.4032 1.9152-3.4032 4.1568v7.4256h-3.6288V7.68962H46.44v1.60321Z"
      />
      <circle cx="12" cy="12" r="12" fill="#00D66F" />
      <path
        fill="#0A2540"
        d="M11.4479 4.80005H7.74707c.72 3.0096 2.82243 5.58235 5.45283 7.19995-2.6352 1.6176-4.73283 4.1904-5.45283 7.2h3.70083c.9168-2.784 3.456-5.2032 6.576-5.6976v-3.0095c-3.1248-.4896-5.664-2.90885-6.576-5.69285Z"
      />
    </svg>
  );
});
LinkIcon.displayName = "LinkIcon";
